import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@omni/ui/components/Button/button.component";

import { SafetyInfoDocumentModel } from "@/api/mappers/safetyInfoDocument.mapper";
import { NumericField } from "@/components/Form/RHF/FormFields/NumericField/NumericField.component";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@/utils/forms/formInfo.provider";
import { OmniFormContextProvider } from "@/utils/forms/omniForm.provider";

import { SafetyDocumentList } from "./documentList/safetyInfoDocumentList.component";
import {
    SafetyInfoFormValidationSchema,
    SafetyInfoFormValues
} from "./safetyInfo.schema";

const FORM_ID = "productSafetyInfoForm";

type SafetyInfoFormProps = {
    isLoading: boolean;
    safetyDocuments: Array<SafetyInfoDocumentModel>;
    onSubmit: (search: number) => void;
};

const SafetyInfo = ({
    isLoading,
    safetyDocuments,
    onSubmit
}: SafetyInfoFormProps) => {
    const { t } = useGranite();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {},
        resolver: yupResolver(SafetyInfoFormValidationSchema)
    });

    const onFormSubmit = ({ search }: SafetyInfoFormValues) => {
        onSubmit(search);
    };

    return (
        <>
            <FormInfoProvider
                formId={FORM_ID}
                withNeverbounce={false}
            >
                {() => (
                    <OmniFormContextProvider {...methods}>
                        <form
                            id={FORM_ID}
                            onSubmit={methods.handleSubmit(onFormSubmit)}
                        >
                            <Row>
                                <Col>
                                    <NumericField<SafetyInfoFormValues>
                                        name="search"
                                        label={t(
                                            "productSafetyInfo.form.search.label"
                                        )}
                                        required
                                        autoComplete={"off"}
                                        placeholder={t(
                                            "productSafetyInfo.form.search.placeholder"
                                        )}
                                        optionalIndication={false}
                                        disabled={isLoading}
                                    />
                                </Col>
                            </Row>
                            <Button
                                test="safetyInfo-button-submit"
                                type={"submit"}
                                color={"success"}
                                disabled={isLoading}
                            >
                                {t("productSafetyInfo.form.submit")}
                            </Button>
                        </form>
                    </OmniFormContextProvider>
                )}
            </FormInfoProvider>
            {safetyDocuments && (
                <SafetyDocumentList documents={safetyDocuments} />
            )}
        </>
    );
};

export { SafetyInfo };
